import {
  FETCH_CARS,
  FETCH_CARS_SUCCESS,
  FETCH_CARS_FAILED,
  EDIT_CAR,
} from "../store/types";
import store from "../store/store";
import { firebase } from "../config/configureFirebase";
import { onValue, update, set, child, remove, push } from "firebase/database";
import { uploadBytesResumable, getDownloadURL } from "firebase/storage";

export const fetchCars = () => (dispatch) => {
  const { carsRef } = firebase;

  dispatch({
    type: FETCH_CARS,
    payload: null,
  });

  const userInfo = store.getState().auth.profile;

  onValue(carsRef(userInfo.uid, userInfo.usertype), (snapshot) => {
    if (snapshot.val()) {
      let data = snapshot.val();
      const arr = Object.keys(data).map((i) => {
        data[i].id = i;
        return data[i];
      });
      dispatch({
        type: FETCH_CARS_SUCCESS,
        payload: arr,
      });
    } else {
      dispatch({
        type: FETCH_CARS_FAILED,
        payload: store.getState().languagedata.defaultLanguage.no_cars,
      });
    }
  });
};

export const editCar = (car, method) => async (dispatch) => {
  const { singleUserRef, carAddRef, carEditRef, carImage } = firebase;
  dispatch({
    type: EDIT_CAR,
    payload: { method, car },
  });
  if (method === "Add") {
    push(carAddRef, car);
  } else if (method === "Delete") {
    remove(carEditRef(car.id));
  } else if (method === "UpdateImage") {
    await uploadBytesResumable(carImage(car.id), car.car_image);
    let image = await getDownloadURL(carImage(car.id));
    let data = car;
    data.car_image = image;
    set(carEditRef(car.id), data);
    if (car.active && car.driver) {
      update(singleUserRef(car.driver), {
        updateAt: new Date().getTime(),
        car_image: image,
      });
    }
  } else {
    set(carEditRef(car.id), car);
  }
};

export const updateUserCarWithImage = (newData, blob) => (dispatch) => {
  const { auth, carAddRef, singleUserRef, carImage } = firebase;

  var carId = push(carAddRef).key;

  uploadBytesResumable(carImage(carId), blob)
    .then(() => {
      blob.close();
      return getDownloadURL(carImage(carId));
    })
    .then((url) => {
      newData.car_image = url;
      set(child(carAddRef, carId), newData);
      if (newData.active) {
        let updateData = {
          carType: newData.carType,
          vehicleNumber: newData.vehicleNumber,
          vehicleMake: newData.vehicleMake,
          vehicleModel: newData.vehicleModel,
          other_info: newData.other_info,
          car_image: url,
          carApproved: newData.approved,
          updateAt: new Date().getTime(),
        };
        update(singleUserRef(auth.currentUser.uid), updateData);
      }
    });
};

export const updateCarWithImage = (carId, newData, blob) => (dispatch) => {
  const { carEditRef, carImage } = firebase;

  if (blob) {
    uploadBytesResumable(carImage(carId), blob)
      .then(() => {
        blob.close();
        return getDownloadURL(carImage(carId));
      })
      .then((url) => {
        newData.car_image = url;
        set(carEditRef(carId), newData);
      });
  } else {
    set(carEditRef(carId), newData);
  }
};

// Función para procesar imagen de aseguranza
export const processInsuranceImage = async (carId, insuranceBlob) => {
  const { carEditRef, carImage } = firebase;
  
  if (insuranceBlob) {
    await uploadBytesResumable(carImage(carId + "_insurance"), insuranceBlob);
    insuranceBlob.close();
    const url = await getDownloadURL(carImage(carId + "_insurance"));
    return url;
  }
  return null;
};

// Función para procesar imagen de inspección
export const processInspectionImage = async (carId, inspectionBlob) => {
  const { carEditRef, carImage } = firebase;
  
  if (inspectionBlob) {
    await uploadBytesResumable(carImage(carId + "_inspection"), inspectionBlob);
    inspectionBlob.close();
    const url = await getDownloadURL(carImage(carId + "_inspection"));
    return url;
  }
  return null;
};

// Función actualizada para manejar múltiples imágenes
export const updateCarWithMultipleImages = (carId, newData, blob, insuranceBlob, inspectionBlob) => async (dispatch) => {
  const { carEditRef, carImage, singleUserRef } = firebase;

  try {
    // Procesar imagen principal del auto
    if (blob) {
      await uploadBytesResumable(carImage(carId), blob);
      blob.close();
      newData.car_image = await getDownloadURL(carImage(carId));
    }

    // Procesar imagen de aseguranza
    if (insuranceBlob) {
      await uploadBytesResumable(carImage(carId + "_insurance"), insuranceBlob);
      insuranceBlob.close();
      newData.insurance = await getDownloadURL(carImage(carId + "_insurance"));
    }

    // Procesar imagen de inspección
    if (inspectionBlob) {
      await uploadBytesResumable(carImage(carId + "_inspection"), inspectionBlob);
      inspectionBlob.close();
      newData.inspection_image = await getDownloadURL(carImage(carId + "_inspection"));
    }

    // Guardar todos los datos
    set(carEditRef(carId), newData);

    // Keep driver profile in sync when active car changes
    if (newData && newData.active && newData.driver) {
      const updateData = {
        carType: newData.carType,
        vehicleNumber: newData.vehicleNumber,
        vehicleMake: newData.vehicleMake,
        vehicleModel: newData.vehicleModel,
        other_info: newData.other_info,
        car_image: newData.car_image,
        carApproved: newData.approved,
        updateAt: new Date().getTime(),
      };
      update(singleUserRef(newData.driver), updateData);
    }
  } catch (error) {
    console.error("Error uploading images:", error);
    // Si hay error, intentar guardar sin las imágenes
    try {
      set(carEditRef(carId), newData);
    } catch (saveError) {
      console.error("Error saving car data:", saveError);
    }
  }
};

// Función actualizada para crear auto con múltiples imágenes
export const updateUserCarWithMultipleImages = (newData, blob, insuranceBlob, inspectionBlob) => async (dispatch) => {
  const { auth, carAddRef, singleUserRef, carImage } = firebase;

  var carId = push(carAddRef).key;
  console.log("Creating car with ID:", carId);
  console.log("Insurance blob exists:", !!insuranceBlob);
  console.log("Inspection blob exists:", !!inspectionBlob);

  try {
    // Procesar imagen principal del auto
    if (blob) {
      console.log("Uploading main car image...");
      await uploadBytesResumable(carImage(carId), blob);
      blob.close();
      newData.car_image = await getDownloadURL(carImage(carId));
      console.log("Main car image uploaded:", newData.car_image);
    }

    // Procesar imagen de aseguranza
    if (insuranceBlob) {
      console.log("Uploading insurance image...");
      await uploadBytesResumable(carImage(carId + "_insurance"), insuranceBlob);
      insuranceBlob.close();
      newData.insurance = await getDownloadURL(carImage(carId + "_insurance"));
      console.log("Insurance image uploaded:", newData.insurance);
    }

    // Procesar imagen de inspección
    if (inspectionBlob) {
      console.log("Uploading inspection image...");
      await uploadBytesResumable(carImage(carId + "_inspection"), inspectionBlob);
      inspectionBlob.close();
      newData.inspection_image = await getDownloadURL(carImage(carId + "_inspection"));
      console.log("Inspection image uploaded:", newData.inspection_image);
    }

    // Guardar auto con todas las URLs de imágenes
    console.log("Saving car data with images...");
    set(child(carAddRef, carId), newData);
    console.log("Car saved successfully");
    
    // Actualizar perfil del usuario si el auto está activo
    if (newData.active) {
      const uid = newData.driver || auth.currentUser?.uid;
      if (!uid) {
        console.error("Unable to sync user profile: missing uid");
        return;
      }
      let updateData = {
        carType: newData.carType,
        vehicleNumber: newData.vehicleNumber,
        vehicleMake: newData.vehicleMake,
        vehicleModel: newData.vehicleModel,
        other_info: newData.other_info,
        car_image: newData.car_image,
        carApproved: newData.approved,
        updateAt: new Date().getTime(),
      };
      update(singleUserRef(uid), updateData);
    }
  } catch (error) {
    console.error("Error uploading images:", error);
    // Si hay error, intentar guardar sin las imágenes
    try {
      set(child(carAddRef, carId), newData);
    } catch (saveError) {
      console.error("Error saving car data:", saveError);
    }
  }
};
